import { useMemo } from 'react';

import { PERMISSIONS, usePlatformAuthorization } from '@/lib/auth';

export const useClipPermissions = () => {
  const { hasPlatformPermission } = usePlatformAuthorization();

  const { canSee, canCreate, canUpdate, canDelete, canExportSponsorshipReport } = useMemo(
    () => ({
      canSee: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.VIEW_CLIP]),
      canCreate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP]),
      canUpdate: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.CREATE_CLIP]),
      canDelete: hasPlatformPermission([PERMISSIONS.MEDIA_MANAGER.DELETE_CLIP]),
      canExportSponsorshipReport: hasPlatformPermission([
        PERMISSIONS.MEDIA_MANAGER.VIEW_SPONSORSHIP_REPORT,
      ]),
    }),
    [hasPlatformPermission]
  );

  return {
    canSee,
    canCreate,
    canUpdate,
    canDelete,
    canExportSponsorshipReport,
  };
};
